<div class="flex flex-col gap-1 text-xs">
	<div class="relative h-4 text-gray-900" aria-hidden="true">
		@for (label of upperTimeLabels(); track label.time) {
			<span class="absolute top-0 -translate-x-1/2 whitespace-nowrap" [style.left]="label.left">{{
				label.time
			}}</span>
		}
	</div>
	<div class="relative h-2.5 overflow-hidden rounded-2xl" role="img" [attr.aria-label]="timelineDescription()">
		@for (segment of segments(); track $index) {
			<div
				class="rounded-xl h-full absolute top-0 {{
					segment.type !== 'closed' && segment.type === state()
						? 'progress-bar-striped progress-bar-animated'
						: ''
				}}"
				[class.bg-gray-100]="segment.type === 'closed'"
				[class.bg-orange-300]="segment.type === 'preTrading'"
				[class.bg-green-500]="segment.type === 'trading'"
				[attr.data-cy]="'market-time-slicer-' + segment.type + '-segment'"
				[style.left]="segment.left"
				[style.width]="segment.width"></div>
		}
	</div>
	<div class="relative h-4 text-gray-900" aria-hidden="true">
		<span class="absolute left-0 top-0">00:00</span>
		@for (label of lowerTimeLabels(); track label.time) {
			<span class="absolute top-0 -translate-x-1/2 whitespace-nowrap" [style.left]="label.left">
				{{ label.time }}
			</span>
		}
		<span class="absolute right-0 top-0">24:00</span>
	</div>
</div>
